// Auf Android 2.3 etc klappt das leider nicht mit reinem Css:
// [type="checkbox"]:not (:checked ) ~ label.checkbox:after, label.checkbox.checked:after
// Der Checkbox wechsel klappt beim css erst, wenn man die orientation ändert.
// Daher hier per Jquery gefixt.
import $ from 'jquery'

$("input[type='checkbox']").change(function () {
    let label = $(this).nextAll("label.checkbox");
    if (label.length > 0) {
        if (this.checked) {
            label.addClass("checked");
            label.removeClass("unchecked");
        } else {
            label.removeClass("checked");
            label.addClass("unchecked");
        }
    }
    return true;
});